import React, { Component } from 'react'
import * as d3 from "d3";
import * as d3Axis from 'd3-axis';
import numeral from "numeral";
import utils from "./utils.js";
const customFormat = (value, format, index) => {
  if (typeof format === 'string') {
    return numeral(value).format(format)
  } else if (typeof format === 'function') {
    return format(value, index)
  } else {
    return value;
  }
}

export default class Axis extends Component {
  componentDidMount() {
    this.renderAxis();
    this.updateCountOfPoints();
  }

  componentDidUpdate() {
    this.renderAxis();
    this.updateCountOfPoints();
  }

  updateCountOfPoints = () => {
    const axis = this.props.axis;

    if (this.props.axisType == 'yAxis' && axis.gridLine != undefined && axis.gridLine.hasOwnProperty('counts') == true) {
      const counts = (axis.gridLine != undefined && axis.gridLine.hasOwnProperty('counts') == true) ? axis.gridLine.counts : { above: 0, middle: 0, below: 0 };
      const rangeValues = this.updateRange();

      if (counts.above != rangeValues.above.length || counts.middle != rangeValues.middle.length || counts.below != rangeValues.below.length) {
        if (axis.gridLine != undefined && axis.gridLine.hasOwnProperty('marker') == true) {
          if (axis.gridLine.marker.onDragEnd != undefined) {
            axis.gridLine.marker.onDragEnd(rangeValues);
          }
        }
      }
    }
  };

  getTicksBuckets(scale, buckets) {
    let domain = [],
      minDomain = scale.domain()[0],
      maxDomain = scale.domain()[scale.domain().length - 1]

    minDomain = Math.round(minDomain * Math.pow(10, 8)) / Math.pow(10, 8), maxDomain = Math.round(maxDomain * Math.pow(10, 8)) / Math.pow(10, 8)

    const domainSplit = (maxDomain - minDomain) / buckets;
    for (let times = 0; times < buckets; times++) {
      domain.push(minDomain + (domainSplit * times));
    }
    domain.push(maxDomain);
    return domain;
  }

  renderAxis() {
    const axisProps = this.props.axis;
    const isSwapAxis = this.props.isSwapAxis;
    const margins = this.props.margins;
    const Id=this.props.id;
    let orient = this.props.axis.orient.toLowerCase();
    const onTicksValueClick=this.props.axis.onTicksValueClick;
    orient = orient.substring(0, 1).toUpperCase() + orient.substr(1);
    const axisType = `axis${orient}`;
    var tickFormat = function(d) {
      return d;
    }; //"0,0.[00]"
    var maxAxisLabelChar = this.props.maxAxisLabelChar;
    tickFormat = axisProps.labels ? (axisProps.labels.format || tickFormat) : tickFormat;
    var formatter = axisProps.labels ? (axisProps.labels.formatter || false) : false;
    var tickPrefix = '';
    tickPrefix = axisProps.labels ? (axisProps.labels.prefix || '') : '';
    var tickPostfix = '';
    tickPostfix = axisProps.labels ? (axisProps.labels.postfix || '') : '';
    var ticks = axisProps.ticks ? axisProps.ticks : null;
    const axis = d3Axis[axisType]()
      .scale(this.props.axis.scale)
      // .ticks(ticks)
      .tickSize(this.props.tickSize != 0 ? -this.props.tickSize : 6)
      .tickFormat(function(d, i) {
        if (typeof(formatter) == 'function') {
          return formatter(d, i)
        } else {
          return tickPrefix + "" + customFormat(d, tickFormat, i) + "" + tickPostfix
        }
      });
    if (axisProps.ticks) {
      axis.tickValues(this.getTicksBuckets(this.props.axis.scale, axisProps.ticks - 1))
    }

    var className = 'AxisClassName_' + (Math.random(5)).toString().split('.').join("_");
    var axisg = d3.select(this.axisElement).attr('class', className).call(axis);
     if (this.props.axisType == 'xAxis' && axisProps.orient.toLowerCase() == 'bottom') {
      //CBT:for highlight ticks value
      axisg.selectAll(".hi-light-ticks").remove();
      if(axisProps.categories!=null && Array.isArray(axisProps.categories)==true){
        axisProps.categories.forEach(function(d,index){
          const isHiLight=(d!=null && typeof(d)=='object') ? (d.hiLight!=null ? true :false) : false;
          
          
          if(isHiLight==true && typeof(d.hiLight)=='object'){
            const fillColor=d.hiLight.fillColor ? d.hiLight.fillColor : "#ccc";
            const height=d.hiLight.height ? d.hiLight.height : "30";
            d=(d!=null && typeof(d)=='object') ? d.data : d; 
            axisg.insert("rect","path")
            .attr("class","hi-light-ticks")
            .attr("x",axisProps.scale(d))
            .attr("y",0)
            .attr("width",axisProps.scale.bandwidth())
            .attr("height",height)
            .style("fill",fillColor);
          }
        })
      }      
     }

    d3.selectAll('.' + className).attr("font-family", "");
    if (this.props.tickSize) {
      //CBT:enable gridLine
      // d3.selectAll('.'+className+' line')
      // .attr("stroke",'#ccc')
      // .attr("stroke-width",'1px');
      var pathd = d3.selectAll('.' + className + ' path').attr("d");
      pathd = pathd.substr(0, pathd.lastIndexOf('.'));
      d3.selectAll('.' + className + ' path').attr("d", pathd);
    }
    var lineColor = axisProps.lineColor || '#000';
    var lineWidth = axisProps.lineWidth || 1;
    var tickColor = axisProps.tickColor || '#000';
    var tickWidth = axisProps.tickWidth || 1;
    var tickstrokeDasharray = axisProps.tickstrokeDasharray || 0;
    var labelStyle = axisProps.labels ? (axisProps.labels.style || {}) : {};
    var rotation = axisProps.labels ? (axisProps.labels.rotation || 0) : 0;
    const translate = axisProps.labels ? (axisProps.labels.translate || "translate(0,0)") : "translate(0,0)";
    // CBT:For Path
    d3.selectAll('.' + className + ' path')
      .style("stroke", lineColor)
      .style("stroke-width", lineWidth);

    // CBT:For Ticks Line
    d3.selectAll("." + className + " .tick line")
      .style("stroke", tickColor)
      .style("stroke-width", tickWidth)
      .style("stroke-dasharray", tickstrokeDasharray);

    var chartWidth = this.props.svgDimensions.width - margins.left - margins.right;
    var chartHeight = this.props.svgDimensions.height - margins.top - margins.bottom;
    if (this.props.axisType == 'xAxis' && axisProps.orient.toLowerCase() == 'bottom') {
      d3.selectAll("." + className + " .tick line")
        .attr("transform", function(d) {
          var that = this;
          return "translate(" + ((chartWidth / axisProps.categories.length) / 2) + ",0)"
        });
      if (axisProps.requiredZeroBaseLine != null && axisProps.requiredZeroBaseLine == true) {
        d3.select(this.zeroBaseLineG).html("");
        d3.select(this.zeroBaseLineG).append("path")
          .attr("d", ` M ${margins.left} ${this.props.yAxisScale.scale(0)} L ${this.props.svgDimensions.width-margins.right} ${this.props.yAxisScale.scale(0)}`)
          .attr("style", utils.convertReactStyleToHtml(axisProps.zeroBaseLineStyle || {}, `stroke-width:${axisProps.lineWidth || 0.5};stroke:${axisProps.lineColor || '#000'}`));
      }

    } else if (this.props.axisType == 'xAxis' && axisProps.orient.toLowerCase() == 'left') {
      d3.selectAll("." + className + " .tick line")
        .attr("transform", function(d) {
          var that = this;
          return "translate(0," + (-1 * ((chartHeight / axisProps.categories.length) / 2)) + ")"
        });
    }

    if (maxAxisLabelChar != null && this.props.axisType == 'xAxis') {
      d3.selectAll("." + className + " .tick text")
        .text(function(d) {
          if (d == null) {
            return "null"
          } else if (d != null && d != undefined && d.length > maxAxisLabelChar) {
            return d.substr(0, maxAxisLabelChar - 3) + "...";
          } else {
            return d;
          }
        })
    }

    var tickLineRequired = (axisProps.tickLineRequired == undefined || axisProps.tickLineRequired == true) ? true : false;
    //CBT: for Text Labels
    var defaultStyle = "";
    if ((axisProps.orient.toLowerCase() == 'bottom' && this.props.axisType == 'xAxis' && tickLineRequired == true && rotation == 0)) {
      defaultStyle = 'transform:translateY(6px);';
    }
    d3.selectAll("." + className + " .tick text")
      .attr("style", utils.convertReactStyleToHtml(labelStyle, defaultStyle));
    //CBT:for onTicksValueClick functionality
    if(onTicksValueClick!=null && typeof(onTicksValueClick)=="function"){
      d3.selectAll("."+ className + " .tick text")
      .style("cursor","pointer")
      .on("click",onTicksValueClick);
    }  
    if (rotation != 0 && this.props.axisType == 'xAxis') {
      d3.selectAll("." + className + " .tick text")
        .attr("transform", function(d) {
          var that = this;
          return `${translate} rotate(${rotation} 0 ${d3.select(that).attr("y")})`
          //return "translate(0,0) rotate("+rotation+" 0 "+d3.select(that).attr("y")+")"
        })

    }
    var chartOriginalWidth = this.props.svgDimensions.width;
    if (this.props.axisType == 'xAxis' && this.props.axis.fixOverlapingLabels) {
      var selectedTextWidth = '';
      d3.selectAll("." + className + " .tick").each(function(text, i) {
        var that = this;
        that.setAttribute("style", "display:block;");
        var position = getTranslation(that.getAttribute("transform"));
        if (i == 0) {
          selectedTextWidth = position[0] + that.getBBox().width;
        } else {
          var currentTextStart = position[0];
          if (currentTextStart <= (selectedTextWidth + 20) || currentTextStart > chartOriginalWidth) {
            that.setAttribute("style", "display:none;");
          } else {
            selectedTextWidth = position[0] + that.getBBox().width;
          }
        }
      });
    }
    if (rotation != 0 && this.props.axisType == 'yAxis') {
      d3.selectAll("." + className + " .tick text")
        .attr("transform", function(d) {
          var that = this;
          return `${translate} rotate(${rotation} 0 ${d3.select(that).attr("x")} 0)`
          //return "translate(0,0) rotate("+rotation+" "+d3.select(that).attr("x")+" 0)"
        })
    }

    //CBT: add extra ticks line
    if (axisProps.orient.toLowerCase() == 'bottom' && this.props.axisType == 'xAxis' && tickLineRequired == true) {
      var that = this;
      d3.selectAll("." + className + " .multiseries-bottomTick").remove();
      var bottomTickG = d3.select(this.axisElement).append("g")
        .attr('class', "multiseries-bottomTick");

      axisProps.categories.forEach(function(d) {
        d=(d!=null && typeof(d)=='object') ? d.data : d;
        bottomTickG.append("line")
          .attr("x1", axisProps.scale(d) + (axisProps.scale.bandwidth() / 2))
          .attr("y1", 0)
          .attr("x2", axisProps.scale(d) + (axisProps.scale.bandwidth() / 2))
          .attr("y2", 6)
          .style("stroke", lineColor)
          .style("stroke-width", tickWidth);
      })
    }



    //CBT:stretch gridline on left and right side
    if (axisProps.orient.toLowerCase() == 'left' && this.props.axisType == 'yAxis') {
      if (axisProps.hasOwnProperty("gridLineStyle") == true) {
        var translateX1 = axisProps.gridLineStyle.translateX1 != null ? axisProps.gridLineStyle.translateX1 : 0;
        var translateX2 = axisProps.gridLineStyle.translateX2 != null ? axisProps.gridLineStyle.translateX2 : 0;
        d3.selectAll("." + className + " .tick line").each(function(line) {
          var self = this;
          var x1 = self.getAttribute("x1") != null ? parseFloat(self.getAttribute("x1")) : 0;
          var x2 = self.getAttribute("x2") != null ? parseFloat(self.getAttribute("x2")) : 0;
          self.setAttribute("x1", (x1 + translateX1));
          self.setAttribute("x2", (x2 + translateX2));
        })
      }
      if (axisProps.hasOwnProperty("tickTranslateY") == true) {
        d3.selectAll("." + className + " .tick text").each(function(text) {
          var tickTranslateY = axisProps.tickTranslateY != null ? axisProps.tickTranslateY : 0;
          var self = this;
          var y = self.getAttribute("y") != null ? parseFloat(self.getAttribute("y")) : 0;
          var height = self.getBBox().height;
          tickTranslateY = tickTranslateY < 0 ? (tickTranslateY - (height / 2)) : (tickTranslateY + (height / 2));
          self.setAttribute("y", (tickTranslateY))
        })
      }
      if (axisProps.hasOwnProperty("tickTranslateX") == true) {
        d3.selectAll("." + className + " .tick text").each(function(text) {
          var tickTranslateX = axisProps.tickTranslateX != null ? axisProps.tickTranslateX : 0;
          var self = this;
          var x = self.getAttribute("x") != null ? parseFloat(self.getAttribute("x")) : 0;
          var width = self.getBBox().width;
          tickTranslateX = tickTranslateX < 0 ? (tickTranslateX - (width / 2)) : (tickTranslateX + (width / 2));
          self.setAttribute("y", (tickTranslateX))
        })
      }
    }

    //CBT:for axis Title start
    var title = axisProps.title || false;
    if (title) {
      var defaultStyle = 'text-anchor:middle;fill:#000;font-size:12px;';
      var titleTextId = 'AxisClassName_' + (Math.random(5)).toString().split('.').join("_");
      var titleText = title.text || '';
      var titleStyle = title.style || {};
      if (this.props.axisType == 'xAxis' && isSwapAxis == 0) {
        //CBT:xAxis title
        d3.selectAll("." + this.props.id + '_xAxisTitle').remove();
        var yPosition = title.yPosition || 0.7;
        axisg.append("text")
          .attr("class", this.props.id + '_xAxisTitle')
          .attr("id", titleTextId)
          .attr("x", this.props.svgDimensions.width / 2)
          .attr("y", margins.bottom * yPosition)
          .attr("style", utils.convertReactStyleToHtml(titleStyle, defaultStyle))
          .text(titleText);
      } else if (this.props.axisType == 'yAxis' && isSwapAxis == 0) {
        //CBT:yAxis title
        if (axisProps.opposite == true) {
          //CBT: right axis title
          d3.selectAll("." + this.props.id + '_yAxisLeftTitle').remove();
          var xPosition = title.xPosition || 0.5;
          axisg.append("text")
            .attr("class", this.props.id + '_yAxisLeftTitle')
            .attr("id", titleTextId)
            .attr("x", (this.props.svgDimensions.height / 2))
            .attr("y", -(margins.right) * xPosition)
            .attr("transform", "rotate(90)")
            .attr("style", utils.convertReactStyleToHtml(titleStyle, defaultStyle))
            .text(titleText);
        } else {
          //CBT: left axis title
          d3.selectAll("." + this.props.id + '_yAxisLeftTitle').remove();
          var xPosition = title.xPosition || 0.5;
          axisg.append("text")
            .attr("class", this.props.id + '_yAxisLeftTitle')
            .attr("id", titleTextId)
            .attr("x", -(this.props.svgDimensions.height / 2))
            .attr("y", -(margins.left) * xPosition)
            .attr("transform", "rotate(-90)")
            .attr("style", utils.convertReactStyleToHtml(titleStyle, defaultStyle))
            .text(titleText);
        }
      } else if (this.props.axisType == 'yAxis' && isSwapAxis == 1) {
        //CBT:xAxis title
        d3.selectAll("." + this.props.id + '_xAxisTitle').remove();
        var yPosition = title.yPosition || 0.7;
        axisg.append("text")
          .attr("class", this.props.id + '_xAxisTitle')
          .attr("id", titleTextId)
          .attr("x", this.props.svgDimensions.width / 2)
          .attr("y", margins.bottom * yPosition)
          .attr("style", utils.convertReactStyleToHtml(titleStyle, defaultStyle))
          .text(titleText);
      } else if (this.props.axisType == 'xAxis' && isSwapAxis == 1) {
        //CBT:yAxis title
        if (axisProps.opposite == true) {
          //CBT: right axis title
          d3.selectAll("." + this.props.id + '_yAxisLeftTitle').remove();
          var xPosition = title.xPosition || 0.5;
          axisg.append("text")
            .attr("class", this.props.id + '_yAxisLeftTitle')
            .attr("id", titleTextId)
            .attr("x", (this.props.svgDimensions.height / 2))
            .attr("y", -(margins.right) * xPosition)
            .attr("transform", "rotate(90)")
            .attr("style", utils.convertReactStyleToHtml(titleStyle, defaultStyle))
            .text(titleText);
        } else {
          //CBT: left axis title
          d3.selectAll("." + this.props.id + '_yAxisLeftTitle').remove();
          var xPosition = title.xPosition || 0.5;
          axisg.append("text")
            .attr("class", this.props.id + '_yAxisLeftTitle')
            .attr("id", titleTextId)
            .attr("x", -(this.props.svgDimensions.height / 2))
            .attr("y", -(margins.left) * xPosition)
            .attr("transform", "rotate(-90)")
            .attr("style", utils.convertReactStyleToHtml(titleStyle, defaultStyle))
            .text(titleText);
        }
      }

    }
    //CBT:for axis Title end


    //CBT: GridLine Start 
    var self = this;
    var gridLine = axisProps.gridLine;
    d3.selectAll("." + this.props.id + '_yAxisGridLine0').remove();
    d3.selectAll("." + this.props.id + '_yAxisGridLine1').remove();
    d3.selectAll("." + this.props.id + '_yAxisGridCircle0').remove();
    d3.selectAll("." + this.props.id + '_yAxisGridCircle1').remove();
    d3.selectAll("." + this.props.id + '_yAxisGridText0').remove();
    d3.selectAll("." + this.props.id + '_yAxisGridText1').remove();
    d3.selectAll("." + this.props.id + '_yAxisGridBackRect_0').remove();
    d3.selectAll("." + this.props.id + '_yAxisGridBackRect_1').remove();
    if (gridLine != null && typeof(gridLine) == 'object' && this.props.axisType == 'yAxis') {
      var typeOfGridLine = gridLine.range || 'both';
      var points = gridLine.points || [{ y1: axisProps.scale.invert(chartHeight * 0.25), y2: axisProps.scale.invert(chartHeight * 0.25) }, { y1: axisProps.scale.invert(chartHeight * 0.75), y2: axisProps.scale.invert(chartHeight * 0.75) }];
      points = points.sort(function(a, b) {
        return a.y1 - b.y1;
      });
      var gridLineColor = "black";
      var gridLineStrokeOpacity = "1";
      var gridLineDashedArray = "6";
      var gridLineMarkerType = 'circle';
      var gridMarkerFillColor = 'black';
      var gridMarkerStrokeColor = 'black';
      var gridMarkerFillOpacity = '1';
      var gridMarkerStrokeOpacity = '1';
      var gridMarkerRadius = 8;
      var gridMarkerWidth = 50;
      var gridMarkerHeight = 20;
      var gridMarkerStrokeWidth = 1;
      var onDragEnd = () => { return 0; };
      var labelFillColor = 'black';
      var labelFontSize = '12px';
      var labelVisible = true;
      var labelPrefix = tickPrefix;
      var labelFormat = tickFormat;
      var labelPostfix = tickPostfix;
      var backRectFillColor = "rgba(21, 137, 164,0.05)";
      var backRectStrokeColor = "rgba(21, 137, 164,0.05)";
      var backRectStrokeWidth = 0;
      var hilightCirlce = null;
      var hilightAbove = {};
      var hilightBellow = {};
      var hilightMiddle = {};


      if (gridLine.hasOwnProperty("backRect") && typeof(gridLine.backRect) == 'object' && gridLine.backRect != null) {
        if (gridLine.backRect.hasOwnProperty("fillColor"))
          backRectFillColor = gridLine.backRect.fillColor;
        if (gridLine.backRect.hasOwnProperty("strokeColor"))
          backRectStrokeColor = gridLine.backRect.strokeColor;
        if (gridLine.backRect.hasOwnProperty("strokeWidth"))
          backRectStrokeWidth = gridLine.backRect.strokeWidth;
      }

      if (gridLine.hasOwnProperty("line") && typeof(gridLine.line) == 'object' && gridLine.line != null) {
        if (gridLine.line.hasOwnProperty("fillColor"))
          gridLineColor = gridLine.line.fillColor;
        if (gridLine.line.hasOwnProperty("strokeOpacity"))
          gridLineStrokeOpacity = gridLine.line.strokeOpacity;
        if (gridLine.line.hasOwnProperty("lineDashedArray"))
          gridLineDashedArray = gridLine.line.lineDashedArray;
      }

      if (gridLine.hasOwnProperty("marker") && typeof(gridLine.marker) == 'object' && gridLine.marker != null) {
        gridLineMarkerType = gridLine.marker.type || 'circle';
        if (gridLine.marker.hasOwnProperty("fillColor"))
          gridMarkerFillColor = gridLine.marker.fillColor;
        if (gridLine.marker.hasOwnProperty("strokeColor"))
          gridMarkerStrokeColor = gridLine.marker.strokeColor;
        if (gridLine.marker.hasOwnProperty("fillOpacity"))
          gridMarkerFillOpacity = gridLine.marker.fillOpacity;
        if (gridLine.marker.hasOwnProperty("strokeOpacity"))
          gridMarkerStrokeOpacity = gridLine.marker.strokeOpacity;
        if (gridLine.marker.hasOwnProperty("radius"))
          gridMarkerRadius = gridLine.marker.radius;
        if (gridLine.marker.hasOwnProperty("strokeWidth"))
          gridMarkerStrokeWidth = gridLine.marker.strokeWidth;
        if (gridLine.marker.hasOwnProperty("onDragEnd"))
          onDragEnd = gridLine.marker.onDragEnd;
        if (gridLine.marker.hasOwnProperty("width"))
          gridMarkerWidth = gridLine.marker.width;
        if (gridLine.marker.hasOwnProperty("height"))
          gridMarkerHeight = gridLine.marker.height;
      }


      if (gridLine.hasOwnProperty("label") && typeof(gridLine.label) == 'object' && gridLine.label != null) {
        if (gridLine.label.hasOwnProperty("fillColor"))
          labelFillColor = gridLine.label.fillColor;
        if (gridLine.label.hasOwnProperty("fontSize"))
          labelFontSize = gridLine.label.fontSize;
        if (gridLine.label.hasOwnProperty("visible"))
          labelVisible = gridLine.label.visible;
        if (gridLine.label.hasOwnProperty("prefix"))
          labelPrefix = gridLine.label.prefix;
        if (gridLine.label.hasOwnProperty("format"))
          labelFormat = gridLine.label.format;
        if (gridLine.label.hasOwnProperty("postfix"))
          labelPostfix = gridLine.label.postfix;
      }

      var mainDivId = self.props.mainDivId;
      var backRectX = 0 - margins.left;
      var backRectWidth = self.props.svgDimensions.width;

      if (typeOfGridLine == 'both') {
        var backRectY_0 = axisProps.scale(points[1]["y1"]) < axisProps.scale(points[0]["y1"]) ? axisProps.scale(points[1]["y1"]) : axisProps.scale(points[0]["y1"]);
        var backRectHeight_0 = Math.abs(margins.top - backRectY_0);

        var backGroundRect_0 = axisg.append("rect")
          .attr('class', self.props.id + '_yAxisGridBackRect_0')
          .attr("x", backRectX)
          .attr("y", margins.top)
          .attr("width", backRectWidth)
          .attr("height", backRectHeight_0)
          .attr("fill", backRectFillColor)
          .attr("stroke", backRectStrokeColor)
          .attr("stroke-width", backRectStrokeWidth)
          .attr("pointer-events", "none");

        var backRectY_1 = axisProps.scale(points[1]["y1"]) > axisProps.scale(points[0]["y1"]) ? axisProps.scale(points[1]["y1"]) : axisProps.scale(points[0]["y1"]);
        var backRectHeight_1 = Math.abs(backRectY_1 - (self.props.svgDimensions.height - margins.bottom));
        var backGroundRect_1 = axisg.append("rect")
          .attr('class', self.props.id + '_yAxisGridBackRect_1')
          .attr("x", backRectX)
          .attr("y", backRectY_1)
          .attr("width", backRectWidth)
          .attr("height", backRectHeight_1)
          .attr("fill", backRectFillColor)
          .attr("stroke", backRectStrokeColor)
          .attr("stroke-width", backRectStrokeWidth)
          .attr("pointer-events", "none");
      } else if (typeOfGridLine == 'middle') {
        var backRectY = axisProps.scale(points[0]["y1"]) < axisProps.scale(points[1]["y1"]) ? axisProps.scale(points[0]["y1"]) : axisProps.scale(points[1]["y1"]);
        var backRectHeight = Math.abs(axisProps.scale(points[0]["y1"]) - axisProps.scale(points[1]["y1"]));

        var backGroundRect = axisg.append("rect")
          .attr('class', self.props.id + '_yAxisGridBackRect_0')
          .attr("x", backRectX)
          .attr("y", backRectY)
          .attr("width", backRectWidth)
          .attr("height", backRectHeight)
          .attr("fill", backRectFillColor)
          .attr("stroke", backRectStrokeColor)
          .attr("stroke-width", backRectStrokeWidth)
          .attr("pointer-events", "none");
      } else if (typeOfGridLine == 'above') {
        var backRectY_0 = axisProps.scale(points[0]["y1"]);
        var backRectHeight_0 = Math.abs(margins.top - backRectY_0);

        var backGroundRect_0 = axisg.append("rect")
          .attr('class', self.props.id + '_yAxisGridBackRect_0')
          .attr("x", backRectX)
          .attr("y", margins.top)
          .attr("width", backRectWidth)
          .attr("height", backRectHeight_0)
          .attr("fill", backRectFillColor)
          .attr("stroke", backRectStrokeColor)
          .attr("stroke-width", backRectStrokeWidth)
          .attr("pointer-events", "none");
      } else if (typeOfGridLine == 'below') {
        var backRectY_1 = axisProps.scale(points[0]["y1"]);
        var backRectHeight_1 = Math.abs(backRectY_1 - (self.props.svgDimensions.height - margins.bottom));
        var backGroundRect_1 = axisg.append("rect")
          .attr('class', self.props.id + '_yAxisGridBackRect_1')
          .attr("x", backRectX)
          .attr("y", backRectY_1)
          .attr("width", backRectWidth)
          .attr("height", backRectHeight_1)
          .attr("fill", backRectFillColor)
          .attr("stroke", backRectStrokeColor)
          .attr("stroke-width", backRectStrokeWidth)
          .attr("pointer-events", "none");
      }
      points.forEach(function(d, index) {
        var className = '';
        var classNameRightCircle = '';
        var classNameRightText = '';
        var gridLineID = '';
        if (index == 0) {
          if (d.y1 == null) {
            d.y1 = axisProps.scale.invert(chartHeight * 0.25);
          }
          if (d.y2 == null) {
            d.y2 = axisProps.scale.invert(chartHeight * 0.25);
          }
          className = self.props.id + '_yAxisGridLine0';
          classNameRightCircle = self.props.id + '_yAxisGridCircle0';
          classNameRightText = self.props.id + '_yAxisGridText0';
          gridLineID = 'yAxisGridLine0_' + (Math.random(5)).toString().split('.').join("_");
        } else {
          if (d.y1 == null) {
            d.y1 = axisProps.scale.invert(chartHeight * 0.75);
          }
          if (d.y2 == null) {
            d.y2 = axisProps.scale.invert(chartHeight * 0.75);
          }
          className = self.props.id + '_yAxisGridLine1';
          classNameRightCircle = self.props.id + '_yAxisGridCircle1';
          classNameRightText = self.props.id + '_yAxisGridText1';
          gridLineID = 'yAxisGridLine1_' + (Math.random(5)).toString().split('.').join("_");
        }
        if (d.x1 == null) {
          d.x1 = 0 - margins.left;
        }
        if (d.x2 == null) {
          d.x2 = chartWidth;
        }

        axisg.append("line")
          .attr('class', className)
          .attr('id', gridLineID)
          .attr("x1", d.x1)
          .attr("y1", axisProps.scale(d.y1))
          .attr("x2", d.x2)
          .attr("y2", axisProps.scale(d.y2))
          .attr("stroke", gridLineColor)
          .attr("stroke-opacity", gridLineStrokeOpacity)
          .attr("stroke-dasharray", gridLineDashedArray);


        var marker = '';
        var bufferPixel = 10;
        if (gridLineMarkerType == 'circle') {
          marker = axisg.append("circle")
            .attr('class', classNameRightCircle)
            .attr("cx", (d.x2 + gridMarkerRadius + bufferPixel))
            .attr("cy", axisProps.scale(d.y1))
            .attr("r", gridMarkerRadius)
            .style("stroke", gridMarkerStrokeColor)
            .style("stroke-opacity", gridMarkerStrokeOpacity)
            .style("stroke-width", gridMarkerStrokeWidth)
            .style("fill", gridMarkerFillColor)
            .style("fill-opacity", gridMarkerFillOpacity);
        }

        if (gridLineMarkerType == 'rectangle') {
          marker = axisg.append("rect")
            .attr('class', classNameRightCircle)
            .attr("x", (d.x2 + bufferPixel))
            .attr("y", (classNameRightCircle == self.props.id + '_yAxisGridCircle0') ? (axisProps.scale(d.y1)) : (axisProps.scale(d.y1) - (gridMarkerHeight)))
            .attr("cy", (classNameRightCircle == self.props.id + '_yAxisGridCircle0') ? (axisProps.scale(d.y1)) : (axisProps.scale(d.y1) - (gridMarkerHeight)))
            .attr("width", gridMarkerWidth)
            .attr("height", gridMarkerHeight)
            .style("stroke", gridMarkerStrokeColor)
            .style("stroke-opacity", gridMarkerStrokeOpacity)
            .style("stroke-width", gridMarkerStrokeWidth)
            .style("fill", gridMarkerFillColor)
            .style("fill-opacity", gridMarkerFillOpacity);
        }


        marker.call(d3.drag()
          .on('start', function() {
            d3.select("." + mainDivId + "_globalTooltipG").style("pointer-events", "none");
          })
          .on('drag', function() {
            //CBT:find Min and Max Range area
            var currentCy = parseFloat(this.getAttribute("cy"));
            var currentClassName = this.getAttribute("class");
            var oppositeClassName = '';
            if (currentClassName == self.props.id + '_yAxisGridCircle0') {
              oppositeClassName = self.props.id + '_yAxisGridCircle1';
            } else {
              oppositeClassName = self.props.id + '_yAxisGridCircle0';
            }
            var oppositeCy = (document.querySelector("." + oppositeClassName) != null) ? (parseFloat(d3.select("." + oppositeClassName).attr("cy"))) : currentCy;
            var minRange = self.props.margins.top;
            if (currentCy > oppositeCy) {
              minRange = oppositeCy;
              if (gridLineMarkerType == 'rectangle') {
                minRange = minRange + gridMarkerHeight;
              }
            }
            var maxRange = self.props.svgDimensions.height - self.props.margins.bottom;
            if (currentCy < oppositeCy) {
              maxRange = oppositeCy;
            }

            if (d3.event.y > minRange && d3.event.y < maxRange) {
              this.setAttribute("cy", d3.event.y);
              this.setAttribute("y", (d3.event.y - (gridMarkerHeight / 2)));
              if (gridLineMarkerType == 'rectangle') {
                this.setAttribute("cy", (currentClassName == self.props.id + '_yAxisGridCircle0') ? (d3.event.y) : (d3.event.y - (gridMarkerHeight)));
                this.setAttribute("y", (currentClassName == self.props.id + '_yAxisGridCircle0') ? (d3.event.y) : (d3.event.y - (gridMarkerHeight)));
              }
              d3.select("#" + gridLineID)
                .attr("y1", d3.event.y)
                .attr("y2", d3.event.y);
              d3.select("." + classNameRightText)
                .text(labelPrefix + "" + customFormat(axisProps.scale.invert(d3.event.y), labelFormat) + "" + labelPostfix);
              var textYPosition = d3.event.y;
              if (gridLineMarkerType == 'rectangle') {
                textYPosition = (currentClassName == self.props.id + '_yAxisGridCircle0') ? (textYPosition + (gridMarkerHeight / 2)) : (textYPosition - (gridMarkerHeight / 2));
              }
              d3.select("." + classNameRightText)
                .attr("y", textYPosition);

              if (typeOfGridLine == 'both') {
                if (currentCy < oppositeCy)
                  d3.select("." + self.props.id + '_yAxisGridBackRect_0').attr("height", Math.abs(margins.top - currentCy));
                else
                  d3.select("." + self.props.id + '_yAxisGridBackRect_1').attr("height", Math.abs((self.props.svgDimensions.height - margins.bottom) - (currentCy)));

                if (gridLineMarkerType == 'rectangle' && currentCy < oppositeCy) {
                  d3.select("." + self.props.id + '_yAxisGridBackRect_0').attr("height", Math.abs(margins.top - (d3.event.y)));
                } else if (gridLineMarkerType == 'rectangle' && currentCy > oppositeCy) {
                  d3.select("." + self.props.id + '_yAxisGridBackRect_1').attr("y", d3.event.y);
                  d3.select("." + self.props.id + '_yAxisGridBackRect_1').attr("height", Math.abs((self.props.svgDimensions.height - margins.bottom) - (d3.event.y)));
                }
              } else if (typeOfGridLine == 'middle') {
                d3.select("." + self.props.id + '_yAxisGridBackRect_0').attr("height", Math.abs(currentCy - oppositeCy));
                if (currentCy < oppositeCy) {
                  d3.select("." + self.props.id + '_yAxisGridBackRect_0').attr("y", d3.event.y);
                }
                if (gridLineMarkerType == 'rectangle') {
                  d3.select("." + self.props.id + '_yAxisGridBackRect_0').attr("height", Math.abs(currentCy - oppositeCy) - (gridMarkerHeight));
                }
              } else if (typeOfGridLine == 'above') {
                d3.select("." + self.props.id + '_yAxisGridBackRect_0').attr("height", Math.abs(margins.top - d3.event.y));
              } else if (typeOfGridLine == 'below') {
                d3.select("." + self.props.id + '_yAxisGridBackRect_1').attr("y", d3.event.y);
                d3.select("." + self.props.id + '_yAxisGridBackRect_1').attr("height", Math.abs((self.props.svgDimensions.height - margins.bottom) - d3.event.y));
              }

              //CBT:for GridLine Start
              if (gridLine.hasOwnProperty("hilightCirlce") && typeof(gridLine.hilightCirlce) == 'object' && gridLine.hilightCirlce != null) {
                if (gridLine.hilightCirlce.hasOwnProperty("above")) {
                  hilightAbove = gridLine.hilightCirlce.above || {};
                }
                if (gridLine.hilightCirlce.hasOwnProperty("bellow")) {
                  hilightBellow = gridLine.hilightCirlce.bellow || {};
                }
                if (gridLine.hilightCirlce.hasOwnProperty("middle")) {
                  hilightMiddle = gridLine.hilightCirlce.middle || {};
                }
                var minRange = d3.event.y < oppositeCy ? d3.event.y : oppositeCy;
                var maxRange = d3.event.y > oppositeCy ? d3.event.y : oppositeCy;
                if (gridLineMarkerType == 'rectangle' && (currentClassName == self.props.id + '_yAxisGridCircle0') && typeOfGridLine != 'above') {
                  minRange = minRange + gridMarkerHeight;
                }
                d3.selectAll(".LineChartMarkerContainer_" + mainDivId).selectAll("circle")
                  .style("fill", function(d) {
                    var currentCy = parseFloat(this.getAttribute("cy"));
                    var currentFillColor = d3.select(this).attr("originalfill");
                    if (currentCy <= minRange && hilightAbove.isHilight == true) {
                      return (hilightAbove.fillColor || '#d0021b')
                    } else if (currentCy >= maxRange && hilightBellow.isHilight == true) {
                      return (hilightAbove.fillColor || '#d0021b')
                    } else if (currentCy >= minRange && currentCy <= maxRange && hilightMiddle.isHilight == true) {
                      return (hilightAbove.fillColor || '#d0021b')
                    } else {
                      return currentFillColor;
                    }
                  });
              }
              //CBT:For GtidLine End
            }
          })
          .on('end', function() {
            // var points={
            //   y1:axisProps.scale.invert(d3.event.y),
            //   y2:axisProps.scale.invert(d3.event.y)
            // }
            d3.select("." + mainDivId + "_globalTooltipG").style("pointer-events", "all");
            //CBT:find Min and Max Range area
            var currentCy = parseFloat(this.getAttribute("cy"));
            var currentClassName = this.getAttribute("class");
            var oppositeClassName = '';
            if (currentClassName == self.props.id + '_yAxisGridCircle0') {
              oppositeClassName = self.props.id + '_yAxisGridCircle1';
            } else {
              oppositeClassName = self.props.id + '_yAxisGridCircle0';
            }
            var oppositeCy = (document.querySelector("." + oppositeClassName) != null) ? (parseFloat(d3.select("." + oppositeClassName).attr("cy"))) : currentCy;
            var minRange = 0;
            if (currentCy > oppositeCy) {
              minRange = oppositeCy;
              if (gridLineMarkerType == 'rectangle') {
                minRange = minRange + gridMarkerHeight;
              }
            }
            var maxRange = self.props.svgDimensions.height - self.props.margins.bottom;
            if (currentCy < oppositeCy) {
              maxRange = oppositeCy;
            }

            onDragEnd(self.updateRange());
          }));

        var textYPosition = axisProps.scale(d.y1);
        if (gridLineMarkerType == 'rectangle') {
          textYPosition = (classNameRightCircle == self.props.id + '_yAxisGridCircle0') ? (textYPosition + (gridMarkerHeight / 2)) : (textYPosition - (gridMarkerHeight / 2));
          gridMarkerRadius = gridMarkerWidth / 2;
        }

        var axisText = axisg.append("text")
          .attr('class', classNameRightText)
          .attr("x", d.x2 + gridMarkerRadius + bufferPixel)
          .attr("y", textYPosition)
          .style("fill", labelVisible ? labelFillColor : "transparent")
          .style("fill-opacity", "1")
          .style("font-size", labelFontSize)
          .style("text-anchor", "middle")
          .style("alignment-baseline", "central")
          .style("pointer-events", "none")
          .text("" + labelPrefix + "" + customFormat(d.y1, labelFormat) + "" + labelPostfix);

      });

    }
    //CBT: GridLine End

  }

  updateRange = () => {
    var minRange = (this.props.axis.gridLine != undefined) ? this.props.axis.gridLine.points[0].y1 : 0,
      maxRange = (this.props.axis.gridLine != undefined && this.props.axis.gridLine.points.length > 1) ? this.props.axis.gridLine.points[1].y1 : minRange,
      minValue = minRange,
      maxValue = maxRange,
      points = this.props.axis.gridLine.points;

    if (document.querySelector("." + this.props.id + '_yAxisGridCircle0')) {
      minRange = parseFloat(d3.select("." + this.props.id + '_yAxisGridCircle0').attr("cy"));
      maxRange = minRange;
      if (document.querySelector("." + this.props.id + '_yAxisGridCircle1') != null)
        maxRange = parseFloat(d3.select("." + this.props.id + '_yAxisGridCircle1').attr("cy"));
      var gridLineMarkerType = 'circle';
      var gridMarkerHeight = undefined;
      if (this.props.axis.gridLine != undefined && this.props.axis.gridLine.hasOwnProperty("marker") == true) {
        if (this.props.axis.gridLine.marker.hasOwnProperty("type") == true)
          gridLineMarkerType = this.props.axis.gridLine.marker.type;
        if (this.props.axis.gridLine.marker.hasOwnProperty("height") == true)
          gridMarkerHeight = this.props.axis.gridLine.marker.height;
      }
      if (gridLineMarkerType == 'rectangle') {
        minValue = this.props.axis.scale.invert(minRange);
        maxValue = points.length > 1 ? (this.props.axis.scale.invert(maxRange + (gridMarkerHeight))) : minValue;
      } else {
        minValue = this.props.axis.scale.invert(minRange);
        maxValue = points.length > 1 ? this.props.axis.scale.invert(maxRange) : minValue;
      }
    }

    if (minValue > maxValue) {
      var tempValue = minValue;
      minValue = maxValue;
      maxValue = tempValue;
    }

    var above = [];
    var below = [];
    var middle = [];

    d3.selectAll(".LineChartMarkerContainer_" + this.props.mainDivId).selectAll("circle")
      .each(function(d) {
        if (d.yAxisValue < minValue) {
          below.push(d)
        } else if (d.yAxisValue > maxValue && points.length > 1) {
          above.push(d)
        } else if (d.yAxisValue >= minValue && d.yAxisValue <= maxValue && points.length > 1) {
          middle.push(d)
        } else if (d.yAxisValue >= minValue && points.length == 1) {
          above.push(d)
        }
      });

    return {
      above,
      below,
      middle,
      minValue,
      maxValue
    };
  }

  render() {
    return (
      <g><g
        className={`Axis Axis-${this.props.axis.orient}`}
        ref={(el) => { this.axisElement = el; }}
        transform={this.props.axis.translate}
      />
      <g transform="translate(0,0)" ref={(el) => { this.zeroBaseLineG = el; }}></g>
      </g>
    )
  }
}

function getTranslation(transform) {
  // Create a dummy g for calculation purposes only. This will never
  // be appended to the DOM and will be discarded once this function
  // returns.
  var g = document.createElementNS("http://www.w3.org/2000/svg", "g");

  // Set the transform attribute to the provided string value.
  g.setAttributeNS(null, "transform", transform);

  // consolidate the SVGTransformList containing all transformations
  // to a single SVGTransform of type SVG_TRANSFORM_MATRIX and get
  // its SVGMatrix.
  var matrix = g.transform.baseVal.consolidate().matrix;

  // As per definition values e and f are the ones for the translation.
  return [matrix.e, matrix.f];
}